import { createSlice } from '@reduxjs/toolkit';

interface CounterState {
  value: number; // Define state shape
}

const initialState: CounterState = { value: 0 }; // Initial state

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1; // Increase counter
    },
    decrement: (state) => {
      state.value -= 1; // Decrease counter
    },
    reset: (state) => {
      state.value = 0; // Reset counter
    },
    logout: (state) => {
      state.value = 0; // Optionally reset state on logout
    },
  },
});

// Export actions and reducer
export const { increment, decrement, reset, logout } = counterSlice.actions;
export default counterSlice.reducer;
